export interface Participant {
  id: string
  name: string
  avatar: string
}

export interface Coffee {
  id: string
  title: string
  description: string
  host: Participant
  date: string
  endTime: string
  platform: 'Google Meet' | 'Microsoft Teams' | 'Zoom' | 'Altro'
  topics: string[]
  type: 'one-to-one' | 'admin'
  participants: Participant[]
  maxParticipants?: number
  meetingLink?: string
  eventType?: 'online' | 'in-person'
  location?: string
}

export const coffeeData: Coffee[] = [
  {
    id: '1',
    title: 'Innovazione nelle strategie ESG',
    description:
      "Discussione su come integrare l'innovazione nelle strategie ESG aziendali per migliorare la sostenibilità e la competitività.",
    host: {
      id: 'admin-1',
      name: 'Greenback Team',
      avatar:
        'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    },
    date: '2024-06-25T14:00:00',
    endTime: '2024-06-25T15:30:00',
    platform: 'Zoom',
    topics: ['ESG', 'Innovazione', 'Sostenibilità Aziendale'],
    type: 'admin',
    eventType: 'online',
    participants: [
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
      {
        id: '2',
        name: 'Laura Bianchi',
        avatar:
          'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: '3',
        name: 'Alessandro Verdi',
        avatar:
          'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: '4',
        name: 'Giulia Neri',
        avatar:
          'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 20,
    meetingLink: 'https://zoom.us/j/123456789',
  },
  {
    id: '2',
    title: 'Economia Circolare nel Settore Moda',
    description:
      'Scambio di idee su come implementare principi di economia circolare nel settore della moda e del tessile.',
    host: {
      id: '2',
      name: 'Laura Bianchi',
      avatar:
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2024-06-20T10:00:00',
    endTime: '2024-06-20T11:00:00',
    platform: 'Google Meet',
    topics: ['Economia Circolare', 'Moda Sostenibile'],
    type: 'one-to-one',
    eventType: 'in-person',
    location: 'Milano, Via Tortona 31 - Impact Hub',
    participants: [
      {
        id: '2',
        name: 'Laura Bianchi',
        avatar:
          'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 2,
  },
  {
    id: '3',
    title: 'Green Finance e Investimenti Sostenibili',
    description:
      'Conversazione sulle opportunità e sfide nel settore della finanza sostenibile e degli investimenti ESG.',
    host: {
      id: '5',
      name: 'Paolo Marini',
      avatar:
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2024-06-22T16:30:00',
    endTime: '2024-06-22T17:30:00',
    platform: 'Microsoft Teams',
    topics: ['Green Finance', 'Investimenti Sostenibili', 'ESG'],
    type: 'one-to-one',
    eventType: 'online',
    participants: [
      {
        id: '5',
        name: 'Paolo Marini',
        avatar:
          'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
    ],
    maxParticipants: 2,
    meetingLink: 'https://teams.microsoft.com/l/meetup-join/123456789',
  },
  {
    id: '4',
    title: 'Energie Rinnovabili: Sfide e Opportunità',
    description:
      'Discussione approfondita sullo stato attuale e futuro delle energie rinnovabili, con focus sulle opportunità di business e le sfide tecnologiche.',
    host: {
      id: '3',
      name: 'Alessandro Verdi',
      avatar:
        'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2024-06-28T11:00:00',
    endTime: '2024-06-28T12:00:00',
    platform: 'Zoom',
    topics: ['Energie Rinnovabili', 'Innovazione', 'Sostenibilità'],
    type: 'one-to-one',
    eventType: 'in-person',
    location: 'Roma, Via del Corso 123 - Caffè Letterario',
    participants: [
      {
        id: '3',
        name: 'Alessandro Verdi',
        avatar:
          'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 2,
  },
  {
    id: '5',
    title: 'Carbon Management e Strategie Net-Zero',
    description:
      'Conversazione sulle strategie di carbon management e i percorsi verso obiettivi net-zero per le aziende.',
    host: {
      id: '6',
      name: 'Chiara Esposito',
      avatar:
        'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2024-07-15T14:00:00',
    endTime: '2024-07-15T15:00:00',
    platform: 'Google Meet',
    topics: ['Carbon Management', 'Sostenibilità Aziendale', 'Net-Zero'],
    type: 'one-to-one',
    eventType: 'online',
    participants: [
      {
        id: '6',
        name: 'Chiara Esposito',
        avatar:
          'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 2,
    meetingLink: 'https://meet.google.com/xyz-abcd-efg',
  },
  {
    id: '6',
    title: 'Workshop: Reporting di Sostenibilità secondo CSRD',
    description:
      'Workshop interattivo sui nuovi requisiti di reporting di sostenibilità secondo la Corporate Sustainability Reporting Directive (CSRD).',
    host: {
      id: 'admin-2',
      name: 'Greenback Academy',
      avatar:
        'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    },
    date: '2024-07-05T15:00:00',
    endTime: '2024-07-05T17:00:00',
    platform: 'Zoom',
    topics: ['ESG', 'Reporting di Sostenibilità', 'CSRD'],
    type: 'admin',
    eventType: 'in-person',
    location: 'Torino, Corso Vittorio Emanuele II 45 - Toolbox Coworking',
    participants: [
      {
        id: '3',
        name: 'Alessandro Verdi',
        avatar:
          'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: '4',
        name: 'Giulia Neri',
        avatar:
          'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: '5',
        name: 'Paolo Marini',
        avatar:
          'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 30,
  },
  {
    id: '7',
    title: 'Transizione Ecologica nel Settore Industriale',
    description:
      'Discussione sulle strategie e tecnologie per guidare la transizione ecologica nelle industrie ad alta intensità energetica.',
    host: {
      id: 'admin-3',
      name: 'Greenback Innovation Hub',
      avatar:
        'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    },
    date: '2024-07-15T16:00:00',
    endTime: '2024-07-15T17:30:00',
    platform: 'Zoom',
    topics: ['Transizione Ecologica', 'Industria 4.0', 'Decarbonizzazione'],
    type: 'admin',
    eventType: 'online',
    participants: [
      {
        id: '4',
        name: 'Giulia Neri',
        avatar:
          'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: '5',
        name: 'Paolo Marini',
        avatar:
          'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
    ],
    maxParticipants: 25,
    meetingLink: 'https://zoom.us/j/987612345',
  },
  {
    id: '8',
    title: 'Biodiversità e Strategie Aziendali',
    description:
      'Come le aziende possono integrare la protezione della biodiversità nelle loro strategie di sostenibilità e creare valore aggiunto.',
    host: {
      id: '7',
      name: 'Marco Ferretti',
      avatar:
        'https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2024-07-18T11:00:00',
    endTime: '2024-07-18T12:00:00',
    platform: 'Google Meet',
    topics: ['Biodiversità', 'Sostenibilità Aziendale', 'Conservazione'],
    type: 'one-to-one',
    eventType: 'in-person',
    location: 'Firenze, Piazza della Repubblica 7 - Biblioteca delle Oblate',
    participants: [
      {
        id: '7',
        name: 'Marco Ferretti',
        avatar:
          'https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 2,
  },
  {
    id: '9',
    title: 'Economia Circolare: Casi di Successo',
    description:
      'Analisi di casi di successo di implementazione di modelli di economia circolare in diversi settori industriali.',
    host: {
      id: '8',
      name: 'Lucia Romano',
      avatar:
        'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2024-07-20T15:30:00',
    endTime: '2024-07-20T16:30:00',
    platform: 'Microsoft Teams',
    topics: ['Economia Circolare', 'Case Studies', 'Innovazione'],
    type: 'one-to-one',
    eventType: 'online',
    participants: [
      {
        id: '8',
        name: 'Lucia Romano',
        avatar:
          'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
    ],
    maxParticipants: 2,
    meetingLink: 'https://teams.microsoft.com/l/meetup-join/987654321',
  },
  {
    id: '10',
    title: 'ESG e Piccole-Medie Imprese',
    description:
      "Strategie pratiche per l'implementazione di politiche ESG nelle PMI con risorse limitate e come trarne vantaggio competitivo.",
    host: {
      id: 'admin-4',
      name: 'Greenback Business Network',
      avatar:
        'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    },
    date: '2024-07-25T14:00:00',
    endTime: '2024-07-25T16:00:00',
    platform: 'Zoom',
    topics: ['ESG', 'PMI', 'Competitività'],
    type: 'admin',
    eventType: 'in-person',
    location: 'Bologna, Via Zamboni 33 - Sala Conferenze Unibo',
    participants: [
      {
        id: '3',
        name: 'Alessandro Verdi',
        avatar:
          'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
    ],
    maxParticipants: 30,
  },
  {
    id: '11',
    title: 'Finanza Sostenibile e Tassonomia UE',
    description:
      'Approfondimento sulla tassonomia UE per le attività sostenibili e le sue implicazioni per investitori e aziende.',
    host: {
      id: '9',
      name: 'Sofia Martini',
      avatar:
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2024-08-02T10:00:00',
    endTime: '2024-08-02T11:00:00',
    platform: 'Google Meet',
    topics: ['Finanza Sostenibile', 'Tassonomia UE', 'Regolamentazione'],
    type: 'one-to-one',
    eventType: 'online',
    participants: [
      {
        id: '9',
        name: 'Sofia Martini',
        avatar:
          'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 2,
    meetingLink: 'https://meet.google.com/stu-vwx-yz',
  },
  // Eventi passati a cui l'utente ha partecipato
  {
    id: '12',
    title: 'Strategie di Reporting ESG Efficaci',
    description:
      'Discussione sulle migliori pratiche per creare report ESG che soddisfino le aspettative degli stakeholder e i requisiti normativi.',
    host: {
      id: 'admin-5',
      name: 'Greenback Sustainability Hub',
      avatar:
        'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    },
    date: '2023-10-15T14:00:00',
    endTime: '2023-10-15T15:30:00',
    platform: 'Zoom',
    topics: ['ESG', 'Reporting', 'Sostenibilità'],
    type: 'admin',
    eventType: 'in-person',
    location: 'Napoli, Via Toledo 256 - Palazzo delle Arti',
    participants: [
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
      {
        id: '3',
        name: 'Alessandro Verdi',
        avatar:
          'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: '4',
        name: 'Giulia Neri',
        avatar:
          'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 25,
  },
  {
    id: '13',
    title: 'Innovazione Sostenibile nei Prodotti di Consumo',
    description:
      "Esplorazione di come l'innovazione sostenibile stia trasformando il design e lo sviluppo dei prodotti di consumo.",
    host: {
      id: '10',
      name: 'Roberto Bianchi',
      avatar:
        'https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    date: '2023-09-22T11:00:00',
    endTime: '2023-09-22T12:00:00',
    platform: 'Microsoft Teams',
    topics: ['Innovazione', 'Design Sostenibile', 'Prodotti di Consumo'],
    type: 'one-to-one',
    eventType: 'online',
    participants: [
      {
        id: '10',
        name: 'Roberto Bianchi',
        avatar:
          'https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
    ],
    maxParticipants: 2,
    meetingLink: 'https://teams.microsoft.com/l/meetup-join/123456789',
  },
  {
    id: '14',
    title: 'Economia Circolare e Supply Chain Sostenibili',
    description:
      'Analisi delle strategie per implementare principi di economia circolare nelle catene di approvvigionamento globali.',
    host: {
      id: 'admin-6',
      name: 'Greenback Circular Economy Lab',
      avatar:
        'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    },
    date: '2023-08-10T15:00:00',
    endTime: '2023-08-10T16:30:00',
    platform: 'Zoom',
    topics: ['Economia Circolare', 'Supply Chain', 'Sostenibilità'],
    type: 'admin',
    eventType: 'in-person',
    location: 'Venezia, Fondamenta Zattere 1392 - Spazio Thetis',
    participants: [
      {
        id: 'current-user',
        name: 'Edoardo Gatner',
        avatar:
          'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
      },
      {
        id: '2',
        name: 'Laura Bianchi',
        avatar:
          'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
      {
        id: '5',
        name: 'Paolo Marini',
        avatar:
          'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      },
    ],
    maxParticipants: 30,
  },
]
